export class ControleEstoqueDetalheLotesRequest {
  searchText?: string;
  idLocalizacaoEstoque?: number | null;
  dataInicial?: string | null;
  dataFinal?: string | null;
  idSituacaoFiltro: number = 0;
}
